module.exports = __webpack_public_path__ + "static/media/Empty_Tube.0457a085.svg";